


























import Vue from 'vue';

import { style } from '@/web/utils/stripe';

export default Vue.extend({
  name: 'StudentChangePaymentCardModal',
  data() {
    return {
      stripeCompleted: false,
      stripeError: false,
      inProgress: false,
    };
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
    studioURL: {
      type: String,
      required: true,
    },
    cardChangedFn: null,
  },
  methods: {
    stripeChangeCallback(event) {
      if (event.complete) {
        this.stripeCompleted = true;
        this.stripeError = false;
      } else if (event.error) {
        this.stripeCompleted = false;
        this.stripeError = event.error.message;
      }
    },
    initStripe(stripePublishableKey) {
      this.stripe = window.Stripe(stripePublishableKey);
      const elements = this.stripe.elements();
      this.card = elements.create('card', {
        style,
        hidePostalCode: true,
      });
      this.card.mount(this.$refs['card-element']);
      this.card.addEventListener('change', this.stripeChangeCallback);
    },
    async changeCard() {
      this.inProgress = true;

      try {
        const setupIntent = await this.$store.dispatch(
          'product/createStripeSetupIntent',
          {
            studioURL: this.studioURL,
            payload: {},
          }
        );
        // const stripeCustomerId = setupIntent.stripe_customer_id;

        const confirmCard = await this.stripe.confirmCardSetup(
          setupIntent.setup_intent.client_secret,
          { payment_method: { card: this.card } }
        );

        await this.cardChangedFn({
          paymentMethod: confirmCard.setupIntent.payment_method,
        });

        this.$emit('close');
        this.$notify({
          group: 'app',
          type: 'success',
          text: this.$t('SETTINGS.TEXT.PAYMENT_METHOD_CHANGE_SUCCESS'),
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          text: error?.response?.data,
        });
      }
      this.inProgress = false;
    },
    async getStripePublishableKey() {
      const product = await this.$store.dispatch(
        'product/getProductForPurchase',
        {
          studioURL: this.studioURL,
          productId: this.productId,
        }
      );
      return product.stripe_publishable_key;
    },
  },
  async mounted() {
    const stripePublishableKey = await this.getStripePublishableKey();
    this.initStripe(stripePublishableKey);
  },
});
